// auth - service
import { useEffect, useState } from "react";
import axios from "axios";

import WebbLoader from "../webx/webb-loader";

export default function AuthServiceModule () {

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    broker: '',
    memo: ''
  });

  useEffect(async() => { 

    const memo = Date.now()
    console.log(memo)

    const basx = 'https://ap-southeast-1.aws.data.mongodb-api.com/app/mintifi-srvc-thzzf/endpoint/demo/service';
    const base = 'https://xhst2dp9ui.execute-api.ap-southeast-1.amazonaws.com/snbx/auth'
    const head = { 
      "Content-Type": "application/json",
      "Authorization": "123"
    }
    const datx = {data: {memo: memo}}
  
    var result;
    try {
      result = await axios.post(base, datx, {headers: head});
      console.log (result.data)
      setData({broker: result.data.broker, memo: result.data.data.data.memo})
    
    } catch (error) {
      console.log (error);
      setData({broker: 'error', memo: 'error'})
    }

    setLoading(false)

  },[])

  if (loading) return WebbLoader;

  return (
  <>
    <p>Auth Service Demo</p>
    <p>broker: {data.broker}</p>
    <p>memo: {data.memo}</p>

  </>

  )
}